/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridViewportChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridViewportChangedEventArgs, _super);
    function GridViewportChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.g = 0;
        _this.d = 0;
        _this.h = 0;
        _this.e = 0;
        _this.f = 0;
        _this.c = 0;
        _this.a = 0;
        _this.b = 0;
        return _this;
    }
    GridViewportChangedEventArgs.$t = markType(GridViewportChangedEventArgs, 'GridViewportChangedEventArgs');
    return GridViewportChangedEventArgs;
}(Base));
export { GridViewportChangedEventArgs };
//# sourceMappingURL=GridViewportChangedEventArgs.js.map
